import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';
import StructuredData from './StructuredData';

interface LocaleWrapperProps {
  children: React.ReactNode;
  seoData?: {
    title?: string;
    description?: string;
    keywords?: string;
    image?: string;
    type?: string;
  };
  structuredDataType?: 'website' | 'photographer' | 'artwork' | 'blogPost' | 'product';
  structuredData?: any;
}

const LocaleWrapper: React.FC<LocaleWrapperProps> = ({ 
  children, 
  seoData = {},
  structuredDataType = 'website',
  structuredData = {}
}) => {
  const { lng } = useParams<{ lng: string }>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const supportedLanguages = ['en', 'es'];
    const currentLanguage = lng || 'en';

    // If no language in URL or unsupported language, redirect to default
    if (!lng || !supportedLanguages.includes(currentLanguage)) {
      const newPath = location.pathname.replace(/^\/(en|es)?/, '/en');
      navigate(newPath, { replace: true });
      return;
    }

    // Change i18n language if different from current
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }

    // Update HTML lang attribute
    document.documentElement.lang = currentLanguage;
  }, [lng, i18n, navigate, location.pathname]);

  return (
    <>
      <SEO {...seoData} />
      <StructuredData type={structuredDataType} data={structuredData} />
      {children}
    </>
  );
};

export default LocaleWrapper;